<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @imp="imp"
                ref="SetBtn"
        ></buttonlist>
        <!--<el-button @click="getInfoById">测试</el-button>-->
        <div id="xpane-0">
        <vxe-table
                ref="singleTable"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:2px"
        >
            <vxe-table-column show-overflow-tooltip field="group_name" :title="$t('getapi[8826]')" width="200"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="model_name" :title="$t('getapi[6842]')" width="200">
            </vxe-table-column>
            <!--<vxe-table-column show-overflow-tooltip field="model_help" title="模块说明" width="200">
                <template scope="scope">
                    <p :v-html="scope.row.model_help"></p>
                </template>
            </vxe-table-column>-->
            <vxe-table-column :title="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">
                        {{$t('getapi[34]')}}
                    </el-button>
                </template>
            </vxe-table-column>
        </vxe-table>
        </div>
        <vxe-table
                ref="tableRef"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:2px;display: none"
        >
            <vxe-table-column show-overflow-tooltip field="model_id" :title="$t('getapi[6841]')" width="200"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="model_name" :title="$t('getapi[6842]')" width="200"></vxe-table-column>

            <vxe-table-column show-overflow-tooltip field="model_help" title="模块说明" width="200">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="group_name" :title="$t('getapi[8826]')" width="200"></vxe-table-column>
        </vxe-table>
        <el-dialog v-dialogDrag :visible.sync="isShowEdit" width="50%">
            <div style="text-align: center;padding: 2px">
                <span>{{dataDetail.model_name}}</span>
            </div>
            <quill-editor
                    ref="text"
                    v-model="dataDetail.model_help"
                    :height="500"
                    class="myQuillEditor"
                    :options="quillOption"
            />
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <serce :isVisible="isVisible" queryData="modelhelp" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import Quill from 'quill';
    import {quillEditor} from 'vue-quill-editor';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {container, ImageExtend} from 'quill-image-extend-module';
    import { Loading } from 'element-ui';
    import quillConfig from '@/utils/config.js';
    import FileSaver from "file-saver";
    import XLSX from "xlsx";
    export default {
        components: {
            quillEditor
        },
        name: 'modelhelp',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                queryData: [], // 查询数组
                pageIndex: 1, // 当前页
                pageSize: 100000, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    id:'',
                    model_id: '',
                    model_name: '',
                    model_help: ''
                },
                quillOption: quillConfig,
                isShowEdit: false,
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView(),
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[13349]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export,import');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.isVisible = false;
                that.getView();
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'modelhelp');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                console.log(data)
                that.$http.urlpost('/Sys/Currency/GetModelExplainInfo', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
                that.authority();
            },
            // 编辑
            edit(row) {
                let that = this
                that.isShowEdit = true
                that.dataDetail.id = row.id
                that.dataDetail.model_id = row.model_id
                that.dataDetail.model_name = row.model_name
                that.dataDetail.model_help = row.model_help
            },
            //保存
            save(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Sys/Currency/SaveModelExplain', parm, function(res) {
                    if(res.Success == 1){
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            exps(){
                /*let that = this
                let parm = {
                    fromname: that.$t('getapi[13349]'),
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Sys/Currency/ExportModelExplain', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this
                const tableElement = this.$refs.tableRef ? this.$refs.tableRef.$el : null;
                if (!tableElement) {
                    console.error('未找到表格引用');
                    return;
                }
                let wb = XLSX.utils.table_to_book(tableElement,{raw:true});
                let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
                try {
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), this.$t("getapi[13349]")+new Date()+'.xlsx');
                } catch (e)
                {
                    if (typeof console !== 'undefined')
                        console.log(e, wbout)
                }
                return wbout
            },
            imp() {
                let item = {
                    label: this.$t("getapi[13354]"),
                    name: 'modelhelpimp',
                    path: '/modelhelpimp',
                    url: '/modelhelpimp',
                    icon: 'video-play'
                };
                this.$router.push({path: '/modelhelpimp'});
                this.$store.commit('selectMenu', item);
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
    /deep/.ql-editor{
        height: 500px
    }
</style>
